import OrderFlowWaiterTable from "./OrderFlowWaiterTable.vue";

export {OrderFlowWaiterTable}
export default OrderFlowWaiterTable
